export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const TOKEN_TYPE = 'Bearer';
export const USER = 'user';
